import React from "react";

/**
 * 不動産の販売・仲介を担う免許業者（グループ会社）の対応案内。
 * 宅建業法の取引主体・免許番号の明示用。文言・免許番号の単一情報源。
 * @param {{ className?: string }} props
 */
const RealEstateAgencyNotice = ({ className = "" }) => (
  <p className={`leading-relaxed ${className}`}>
    物件の販売や仲介については
    <span className="font-medium">
      「アプロホールディングス株式会社 河口湖支店{" "}
      <a href="tel:0555256102" className="underline underline-offset-2">
        0555(25)6102
      </a>{" "}
      国土交通大臣(1)第10291号」
    </span>
    が対応いたします。
  </p>
);

export default RealEstateAgencyNotice;
